// ============================================================================
// PairsForm — Défilement à la navigation (retour FX 2026-10-13)
// ============================================================================
// React Router ne touche pas au défilement : depuis un catalogue déroulé, la
// fiche suivante s'ouvrait à la même hauteur (« la page s'ouvre en plein
// milieu » sur téléphone — invisible sur ordinateur, où la liste tient sans
// défiler). Règle : une NOUVELLE page s'ouvre en haut ; Retour / Avant du
// navigateur (POP) retrouve la position quittée ; un changement de paramètres
// de requête sur la même page (filtres) ne bouge pas. Monté une fois dans
// App.tsx — ne pas poser de scrollTo par page.
// ============================================================================

import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/** Position quittée, par clé d'entrée d'historique (vit le temps de l'onglet). */
const positions = new Map<string, number>();

export default function ScrollRestauration() {
  const { pathname, key } = useLocation();
  const navigationType = useNavigationType();
  const cheminPrecedent = useRef(pathname);

  // Le navigateur ne doit pas restaurer lui-même (il le fait trop tard, après
  // le rendu de l'ancienne page) : on s'en charge.
  useEffect(() => {
    try {
      if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    const precedent = cheminPrecedent.current;
    cheminPrecedent.current = pathname;
    if (navigationType === "POP") {
      window.scrollTo({ top: positions.get(key) ?? 0, left: 0 });
      return;
    }
    if (precedent !== pathname) window.scrollTo({ top: 0, left: 0 });
    // Une seule dépendance voulue : la clé change à chaque navigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => {
    const memoriser = () => {
      positions.set(key, window.scrollY);
    };
    window.addEventListener("scroll", memoriser, { passive: true });
    return () => window.removeEventListener("scroll", memoriser);
  }, [key]);

  return null;
}
